module.exports = __webpack_public_path__ + "static/media/tecnologico.5e337ed4.png";